import { render, staticRenderFns } from "./NationalPatentAuthorityForm.vue?vue&type=template&id=36b1c55b&"
import script from "./NationalPatentAuthorityForm.vue?vue&type=script&lang=js&"
export * from "./NationalPatentAuthorityForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentAuthorityForm.vue?vue&type=style&index=0&id=36b1c55b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports